<div class="td-wb-radio-group"
     role="radiogroup"
     [attr.aria-label]="ariaLabel()"
     [attr.aria-labelledby]="ariaLabelledBy()"
     [class.td-wb-radio-group--vertical]="isVertical()">
  <ng-content />
</div>
